import React from 'react';
import styled from 'styled-components';
import images from '../../Theming/images';

const Logo = styled.img``;

const ItvSquareLogo: React.FC<React.CSSProperties> = ({
  height = 15,
  ...rest
}) => {
  return (
    <Logo id="itv-logo" src={images.ItvX} alt="Itv logo" style={{ ...rest }} />
  );
};

export default ItvSquareLogo;
